import React, { Component, type ComponentType } from 'react';
import { ComponentWithAnalytics } from '@atlassian/jira-analytics-web-react/src';
import type { IssueId } from '../../../../../model/issue';
import { FlatItems, type ItemMeta } from '../../../common/components/flat-items';
import type {
	TableCommonProps,
	ListItem,
	ListChildItem,
	OnItemExpandChanged,
} from '../../../common/types';
import type { APIProps as ListItemProps } from '../../list-item';
import type { APIProps as ListItemContentProps } from '../../list-item-content';
import type { APIProps as ListItemContentTooltipProps } from '../../list-item-content-tooltip';

type Components = {
	ListItem: ComponentType<ListItemProps>;
	ListItemContent: ComponentType<ListItemContentProps>;
	ListItemContentTooltip: ComponentType<ListItemContentTooltipProps>;
};

type Props = TableCommonProps & {
	items: ListItem[];
	selectedItemId: IssueId | undefined;
	components: Components;
	onItemExpandChanged: OnItemExpandChanged;
};

// eslint-disable-next-line jira/react/no-class-components
export class ListItems extends Component<Props> {
	static defaultProps = {
		items: [],
		expandedItems: {},
	};

	renderItem = (item: ListItem | ListChildItem, { parentId, isParent, isExpanded }: ItemMeta) => {
		const {
			isSelectEnabled,
			itemHeight,
			selectedItemId,
			components,
			onItemClick,
			onItemExpandChanged,
		} = this.props;

		const { id, level } = item;
		return (
			<components.ListItem
				key={id}
				id={id}
				parentId={parentId}
				itemHeight={itemHeight}
				level={level}
				isSelectEnabled={isSelectEnabled}
				isSelected={id !== undefined && id === selectedItemId}
				isParent={isParent}
				isExpanded={isExpanded}
				onClick={onItemClick}
				onExpandChanged={onItemExpandChanged}
				Content={components.ListItemContent}
				ContentTooltip={components.ListItemContentTooltip}
			/>
		);
	};

	render() {
		const { items, expandedItems, activeLevel } = this.props;

		return (
			<FlatItems
				items={items}
				expandedItems={expandedItems}
				activeLevel={activeLevel}
				renderItem={this.renderItem}
			/>
		);
	}
}

export default ComponentWithAnalytics('listItem', {
	onItemClick: 'clicked',
	onItemExpandChanged: 'expansionStateChanged',
})(ListItems);
